import React from 'react';
import { produce } from 'immer';

import { ClaimFileType } from '../types';
import { UploaderFilesListProps } from '../../../common/Uploader';
import BasicSelect from '../../../common2/BasicSelect';
import Text from '../../../common/Text';
import IconButton from '../../../common2/IconButton';
import ValidationError from '../../../common/ValidationError';

import RemoveIcon from '../../../../icons/close.svg';

import styles from './FilesListWithTypes.scss';

const fileTypeOptions = [
  { value: ClaimFileType.DECLARATION_OF_RECIPIENT, label: 'Declaration of recipient' },
  { value: ClaimFileType.TRACKING_SCREENSHOT, label: 'Tracking screenshot' },
  { value: ClaimFileType.INVOICE_DOCUMENT, label: 'Invoice' },
  { value: ClaimFileType.PICTURE_OF_DAMAGE, label: 'Picture of damage' },
  { value: ClaimFileType.PICTURE_OF_MISSING_ITEM, label: 'Picture of missing item' },
  { value: ClaimFileType.REGRESS_INVOICE, label: 'Carrier claim invoice' },
  { value: ClaimFileType.PROOF_OF_CONSUMER_PAYMENT, label: 'Proof of consumer payment' },
  { value: ClaimFileType.DATA_PROCESSING_CONSENT, label: 'Data processing consent' },
];

function FilesListWithTypes(props: UploaderFilesListProps) {
  const { errors = {}, files = [], onFilesChange } = props;

  const updateFileType = (fileId: string, fileType: ClaimFileType) =>
    produce(files, (draftFiles) => {
      const file = draftFiles.find((file) => file.id === fileId);

      if (file) {
        file.fileType = fileType;
      }
    });

  if (!files.length) {
    return null;
  }

  return (
    <div className={styles.list} aria-label="Files list">
      <Text ink>File name</Text>
      <Text ink>Document type</Text>
      <div />
      {files.map((file) => (
        <>
          <Text key={`${file.id}-name`} className={styles.item}>
            {file.name}
          </Text>
          <div key={`${file.id}-type`} className={styles.item}>
            <BasicSelect
              ariaLabel={`${file.name} document type`}
              placeholder="Select..."
              value={file.fileType}
              isInvalid={!!errors[file.id]?.fileType}
              options={fileTypeOptions}
              onChange={(fileType: ClaimFileType) => onFilesChange(updateFileType(file.id, fileType))}
              menuPlacement="auto"
              useMenuPortal
            />
          </div>
          <div key={`${file.id}-remove-button`} className={styles.item}>
            <IconButton
              variant="ghost"
              icon={RemoveIcon}
              ariaLabel={`${file.name} remove`}
              onClick={() => onFilesChange(files.filter((f) => f.id !== file.id))}
            />
          </div>
          {errors[file.id]?.fileType && (
            <div key={`${file.id}-error`} className={styles.errorLine}>
              <ValidationError>You must select a document type</ValidationError>
            </div>
          )}
        </>
      ))}
    </div>
  );
}

export default React.memo(FilesListWithTypes);
